export enum Id24State {
    Authorized = "authorized",
    Unauthorized = "unauthorized",
    Uninitialized = "uninitialized",
  }
  